// extracted by mini-css-extract-plugin
module.exports = {"loadingDivShow":"PleaseWait_loadingDivShow__1A3A_","loadingDivHide":"PleaseWait_loadingDivHide__2ijyx"};